import { render } from "./PermissionGroups.vue?vue&type=template&id=42f58b4f&scoped=true"
import script from "./PermissionGroups.vue?vue&type=script&lang=js"
export * from "./PermissionGroups.vue?vue&type=script&lang=js"

import "./PermissionGroups.vue?vue&type=style&index=0&id=42f58b4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f58b4f"]])

export default __exports__